import { render, staticRenderFns } from "./LedgerSignTransactionModal.vue?vue&type=template&id=1ca256c4&scoped=true"
import script from "./LedgerSignTransactionModal.vue?vue&type=script&lang=js"
export * from "./LedgerSignTransactionModal.vue?vue&type=script&lang=js"
import style0 from "./LedgerSignTransactionModal.vue?vue&type=style&index=0&id=1ca256c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca256c4",
  null
  
)

export default component.exports